import React from 'react';
import './Services.css';
import Unicode from '../util/unicode';

const Services = () => {
  const services = [
    {
      icon:  '1F5A5',
      title: 'Hardware Sales & Installation',
      description: 'Premium IT hardware solutions with professional installation and setup services.',
      path: '/services/hardware-installation'
    },
    {
      icon: '1F310',
      title: 'Network Maintenance',
      description: 'Comprehensive network monitoring, maintenance, and optimization services.',
      path: '/services/network-setup'
    },
    {
      icon: '1F527',
      title: 'Technical Support',
      description: '8 X 6 technical support to keep your systems running smoothly and efficiently.',
      path: '/services/technical-support'
    },
    {
      icon: '2601',
      title: 'Cloud Solutions',
      description: 'Modern cloud infrastructure setup and migration services for your business.',
      path: '/services/cloud-services'
    },
    {
      icon: '1F512',
      title: 'Security Solutions',
      description: 'Advanced cybersecurity measures to protect your data and network infrastructure.',
      path: '/services/security-solutions'
    },
    {
      icon: '1F50A',
      title: 'System Monitoring',
      description: 'Real-time system monitoring and performance optimization for maximum uptime.',
      path: '/services/server-management  '
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-header">
          <h2 className="section-title">Our Services</h2>
          <p className="section-description">
            Comprehensive IT solutions tailored to meet your business needs
          </p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon"><Unicode code={service.icon} />&#xFE0E;</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <a href={service.path} className="service-link">Learn More →</a>
            </div>
          ))}
        </div>
        
        <div className="services-cta">
          <h3>Ready to Get Started?</h3>
          <p>Contact us today for a free consultation and personalized quote</p>
          <a href="#quote" className="btn btn-primary">Get Your Quote</a>
        </div>
      </div>
    </section>
  );
};

export default Services;
